// Os grupos "Gestão" e "Nexus IA" do menu lateral, com um item por seção (como
// Relatórios e Configurações). Cada item só aparece se a empresa (ou a pessoa,
// na Auditoria) tem o recurso dele; a permissão por papel o menu tira da rota.
// Entra no Sidebar.vue do core por um patch (ver custom/docs/PATCHES.md). O
// ícone também aparece em NexusSecao.vue, senão o Tailwind não o gera (ele não
// lê os .js desta pasta).
import { computed } from 'vue';
import { useStore } from 'vuex';
import { useAccount } from 'dashboard/composables/useAccount';
import { useRecursos, secoesLiberadas } from './recursos';
import messages from './i18n';
import mensagensDaGestao from '../gestao/i18n';
import mensagensDosAplicativos from '../aplicativos/i18n';

// Os aplicativos da conta são buscados uma vez (a aba da conversa também os usa).
let aplicativosPedidos = false;

// Gestão: Monitoramento e modo TV (administrador), a Nexus Neural (vitrine da
// IA) e a Auditoria (por pessoa), com as abas dela dentro da mesma tela.
const GESTAO = [
  {
    id: 'MONITORAMENTO',
    rota: 'neuxs_gestao_monitoramento',
    recurso: 'administrador',
  },
  { id: 'TV', rota: 'neuxs_gestao_tv', recurso: 'administrador' },
  { id: 'TEIA', rota: 'neuxs_nexus_teia', recurso: 'ia' },
  { id: 'AUDITORIA', rota: 'neuxs_gestao_auditoria', recurso: 'auditoria' },
  { id: 'MINHAS', rota: 'neuxs_gestao_minhas', recurso: 'minhas_avaliacoes' },
];

export const useNexusMenu = () => {
  const { accountScopedRoute } = useAccount();
  // Direto do i18n.js: um segundo useI18n (com mensagens) no Sidebar do core
  // brigaria com o dele.
  const textos = messages.pt_BR.NEUXS_NEXUS;
  const daGestao = mensagensDaGestao.pt_BR.NEUXS_GESTAO;
  const recursos = useRecursos();
  const store = useStore();
  if (!aplicativosPedidos) {
    aplicativosPedidos = true;
    store.dispatch('dashboardApps/get');
  }

  return computed(() => {
    const grupos = [];
    const gestao = GESTAO.filter(secao => recursos.value?.[secao.recurso]).map(
      secao => ({
        name: `NeuxsGestao${secao.id}`,
        label: daGestao.MENU[secao.id] || textos.MENU[secao.id],
        to: accountScopedRoute(secao.rota),
      })
    );
    if (gestao.length) {
      grupos.push({
        name: 'NeuxsGestao',
        label: daGestao.TITULO,
        icon: 'i-lucide-gauge',
        children: gestao,
      });
    }

    // A Nexus Neural mudou para a Gestão; o atalho /nexus ainda leva a ela.
    const itens = secoesLiberadas(recursos.value)
      .filter(secao => secao.id !== 'TEIA')
      .map(secao => ({
        name: `NeuxsNexus${secao.id}`,
        label: textos.MENU[secao.id] || textos.ABAS[secao.id],
        to: accountScopedRoute(secao.rota),
      }));
    if (itens.length) {
      grupos.push({
        name: 'NeuxsNexus',
        label: textos.TITULO,
        icon: 'i-lucide-radio-tower',
        children: itens,
      });
    }
    // Aplicativos (Integrações → Painel de Aplicativos) em tela cheia.
    const apps = store.getters['dashboardApps/getRecords'] || [];
    if (apps.length) {
      grupos.push({
        name: 'NeuxsAplicativos',
        label: mensagensDosAplicativos.pt_BR.NEUXS_APLICATIVOS.TITULO,
        icon: 'i-lucide-app-window',
        children: apps.map(app => ({
          name: `NeuxsAplicativo${app.id}`,
          label: app.title,
          to: accountScopedRoute('neuxs_aplicativos', { appId: app.id }),
        })),
      });
    }
    return grupos;
  });
};
